import { render, staticRenderFns } from "./prize-competition-success.vue?vue&type=template&id=5f473c48&scoped=true&lang=pug"
import script from "./prize-competition-success.vue?vue&type=script&setup=true&lang=js"
export * from "./prize-competition-success.vue?vue&type=script&setup=true&lang=js"
import style0 from "./prize-competition-success.vue?vue&type=style&index=0&id=5f473c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f473c48",
  null
  
)

export default component.exports